import { render, staticRenderFns } from "./BaseSelectorNoDefault.vue?vue&type=template&id=5f81c618"
import script from "./BaseSelectorNoDefault.vue?vue&type=script&lang=js"
export * from "./BaseSelectorNoDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports